import Pagination from './Pagination';
import './Pagination.scss';

export default Pagination;
